// @ts-nocheck
import React, { createRef } from "react";
import { ModalWithComponent } from "../../../../base/basicComponents/modal";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import BaseApplyJb from "../baseApplyJb";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import ApplyForJbApproveSection from "../../../sections/applyForJbSection/applyForJbApproveSection";
import {
  actions,
  dataStatus,
  handleApproveApplyJBSortFile,
  procedureJbStatus,
  savedInRadioValues,
} from "../../../publicDictionaryValues";
import Buttons from "../../../../base/basicComponents/button";
import styles from "../index.module.scss";
import applyForJbService from "../../../../service/applyForJb/applyForJbService";
import appService from "../../../../service/app";
import { disableInteraction, enableInteraction } from "utils";
import { bindUnloadUnlock } from "utils/lockUnload";

const procedureFileRef = createRef();
const applyJbApproveRef = createRef();

export default class ApproveApplyJb extends BaseApplyJb {
  constructor(props: any) {
    super(props);
    const { rejectReason, rejectStatus } = this.props.pageProps;
    this.state = {
      pageState: {
        rejectReason,
        rejectStatus,
        isCancelDisabled: false,
        isSubmitDisabled: false,
        isRejectDisabled: false,
        isTableBorderError: false,
        isChange: false,
      },
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
      loading: false,
      modalState: {
        modalTitle: "",
        modalLabel: "",
        okText: "",
        cancelText: "",
        actionType: "",
        closable: false,
        isOkBtnDisabled: false,
        isCancelBtnDisabled: false,
        maskClosable: false,
        isModalWithComponentOpen: false,
        isShowTextArea: false,
        textAreaPlacement: "",
        textAreaMaxLength: 0,
        textAreaClassName: "",
        isShowSelect: false,
        isShowTextAreaAndUploadDragger: false,
        uploadDraggerFileType: "",
        rowIndex: 0,
        fileIds: [],
        fileNames: [],
        modalWidth: 520,
      },
    };
    // @ts-ignore
    this.modalContentLabels = {
      submitConfirmModalLabel: <span className={styles.modalText}>Are you sure to submit?</span>,
      cancelConfimModalLabel: (
        <span className={styles.modalText}>Are you sure to quit without saving?</span>
      ),
    };
  }

  handleFileData = (files: any) => {
    const dataList: any[] = [];
    if (files === null || files === undefined) {
      return;
    }
    const newFiles = handleApproveApplyJBSortFile(files, this._formateDate);
    newFiles.forEach((item) => {
      const lineId = this._generateGUID();
      dataList.push({
        data: [
          { name: "lineId", value: lineId },
          { name: "procedureFileID", value: item.procedureFileID },
          { name: "fileId", value: item.fileID },
          { name: "fileKey", value: item.fileKey },
          {
            name: "fileName",
            value: item.fileName,
            tagValue: item.fileTagID,
          },
          {
            name: "uploadedDate",
            value: this._formateDate(item.createdDate),
          },
          { name: "uploadByName", value: item.uploadByName },
          { name: "uploadBy", value: item.uploadedBy },
          {
            name: "approveDate",
            value: this._formateDate(item.modifiedDate),
          },
          { name: "fileOperate", value: 1 },
          { name: "status", value: "" },
          { name: "dataStatusID", value: "" },
          { name: "previousStatus", value: "" },
          // @ts-ignore
          { name: "jbProcedure", value: procedureJbStatus[item.jbProcdure] },
          {
            name: "applyfor",
            // @ts-ignore
            value: item.jbProcdure !== item.applyfor ? procedureJbStatus[item.applyfor] : "",
            optionList: [],
          },
          { name: "isDelete", value: item.isDelete },
          { name: "rejectReason", value: item.rejectReason },
          { name: "attachmentFileID", value: item.attachmentFileID },
          {
            name: "attachment",
            value: item.attachmentName,
            fileId: item.attachmentFileID,
          },
          {
            name: "procedureApplyJBStatusID",
            value: item.procedureApplyJBStatusID,
          },
        ],
        checked: false,
      });
    });
    return dataList;
  };

  handleSubmitFileData = (data: any, actionID: any) => {
    if (data === undefined) {
      return [];
    }

    return data.map((item: any) => {
      return {
        fileTagID: item.data.find((x: any) => x.name === "fileName").tagValue,
        procedureFileKey: item.data.find((x: any) => x.name === "fileKey").value,
        procedureFileId: item.data.find((x: any) => x.name === "procedureFileID").value,
        rejectReason: item.data.find((x: any) => x.name === "rejectReason").value,
        attachmentFileID: item.data.find((x: any) => x.name === "attachmentFileID").value,
        attachmentName: item.data.find((x: any) => x.name === "attachment").value,
        actionID: actionID,
        dataStatusID: item.data.find((x: any) => x.name === "status").value,
        procedureApplyJBStatusID: item.data.find((x: any) => x.name === "procedureApplyJBStatusID")
          .value,
      };
    });
  };

  handleReturnPageName = () => {
    return "Approve JB Procedure";
  };

  handleReturnShareTaskSection = () => {
    const { shareTaskData } = this.props;

    return <ActiveShareTaskReadOnly shareTaskData={shareTaskData} />;
  };

  handleReturnProcedureFileSection = () => {
    const { applyJBStatus } = this.props;

    return (
      // @ts-ignore
      <ApplyForJbApproveSection
        ref={applyJbApproveRef}
        procedureFileRef={procedureFileRef}
        serverPathValue={applyJBStatus.clientServerPath}
        savedInRadioValue={applyJBStatus.procedureSaveInCategoryID}
        procedureJbStatusId={applyJBStatus.jbProcedureSavedIn}
        applyfor={
          applyJBStatus.applyfor !== applyJBStatus.jbProcedureSavedIn ? applyJBStatus.applyfor : ""
        }
        procedureFileData={this.handleFileData(applyJBStatus.applyJBStatusFilesList)}
        rejectReason={applyJBStatus.rejectReason}
        isUpdateClientServerPath={applyJBStatus.isChangeClientServerPath}
        isUpdateProcedureSavedIn={applyJBStatus.isChangeProcedureSavedIn}
      />
    );
  };

  handleCreateActionClickSectionCheckModal = (
    modalTitle: any,
    modalLabel: any,
    okMethod: any,
    cancelMethod: any
  ) => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: true,
        modalTitle: modalTitle,
        modalLabel: modalLabel,
        okText: "Confirm",
        cancelText: "Cancel",
        modalWidth: 520,
        handleOk: okMethod,
        handleCancel: cancelMethod,
      },
    });
  };

  handleCancelOkClick = () => {
    this.setState({
      pageState: { ...this.state.pageState, isCancelDisabled: true },
    });
    this.hideModal();
    this.props.closePage();
  };

  // @ts-ignore
  handleCancelClick = () =>
    this.handleCreateActionClickSectionCheckModal(
      "",
      this.modalContentLabels.cancelConfimModalLabel,
      this.handleCancelOkClick,
      this.hideModal
    );

  handleReturnCancelButton = (isCancelDisabled: any) => (
    <Buttons
      color="grey"
      size="middle"
      onClick={this.handleCancelClick}
      disabled={isCancelDisabled}
      btnClassName={styles.approveActionBtn}
      testid="apply-jb-cancel-btn"
    >
      Cancel
    </Buttons>
  );

  handleControlErrorScroll = (top: any) => window.scrollTo(0, top || 0);

  handleCheckServerPathHighLight = () => {
    // @ts-ignore
    applyJbApproveRef.current.setServerPathError();
    // @ts-ignore
    applyJbApproveRef.current !== null &&
      this.handleControlErrorScroll(applyJbApproveRef.current.getServerPathOffset());
  };

  handleApproveSubmitClickCheckRequired = () => {
    this.handleCheckServerPathHighLight();
  };

  handleReturnSubmitData = (actionID: any, actionName: any, listData: any) => {
    const applyJbData = listData;

    return {
      isChangeClientServerPath: this.props.applyJBStatus.isChangeClientServerPath,
      isChangeProcedureSavedIn: this.props.applyJBStatus.isChangeProcedureSavedIn,
      clientServerPath: this.props.applyJBStatus.clientServerPath,
      procedureProcessId: this.props.pageProps.procedureProcessId,
      procedureId: this.props.params.ProcedureID,
      procedureTaskId: this.props.params.ProcedureTaskId,
      workflowProcessInstanceId: this.props.params.WorkflowProcessInstanceId,
      flowCategoryID: this.props.params.FlowCategoryID,
      procedureStepID: this.props.params.ProcedureStepID,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      // @ts-ignore
      rejectReason: applyJbApproveRef.current.getServerPathReturnReasonValue(),
      jbProcedureSavedIn: this.props.applyJBStatus.jbProcedureSavedIn,
      applyfor:
        this.props.applyJBStatus.applyfor !== this.props.applyJBStatus.jbProcedureSavedIn
          ? this.props.applyJBStatus.applyfor
          : "",
      // @ts-ignore
      jBProcedureSavedInStatusID: applyJbApproveRef.current.getServerPathStatus(),
      fileList: this.handleSubmitFileData(applyJbData, actionID),
    };
  };

  _applyJBStatusTriggerSuccess = (response: any) => {
    if (response.succeeded === false) {
      console.log(response.message);
    } else {
      this.props.closePage();
    }
    this._hideLoading();
  };

  _applyJBStatusTriggerError = (response: any) => {
    console.log(response);
  };

  applyJBStatusTriggerAction = (para: any) => {
    applyForJbService.applyJBStatusTriggerStepAction(
      para,
      this._applyJBStatusTriggerSuccess,
      this._applyJBStatusTriggerError
    );
  };

  handleSubmitOkClick = (procedureFileData: any) => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isSubmitDisabled: true,
      },
    });
    this.props._showLoading();
    this.hideModal();
    let isTableDataReturn = false;
    // @ts-ignore
    const isServerPathReturn =
      applyJbApproveRef.current !== null &&
      applyJbApproveRef.current.getServerPathStatus() === dataStatus.reject;
    const fileList = procedureFileData;
    try {
      fileList.forEach((fileData: any, index: any) => {
        const statusData = fileData.data.find((item: any) => item.name === "status");
        isTableDataReturn = statusData.value === dataStatus.reject;
        if (isTableDataReturn) {
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    let para;
    if (isTableDataReturn || isServerPathReturn) {
      para = this.handleReturnSubmitData(actions.reject, "Reject", fileList);
    } else {
      para = this.handleReturnSubmitData(actions.approve, "Approve", fileList);
    }
    this.applyJBStatusTriggerAction(para);
  };

  handleApproveSubmitClickCheck = (procedureFileData: any, tableErrorList: any) => {
    let isTableError = false;
    const errorIndexList: any[] = [];
    this.props.applyJBStatus.procedureSaveInCategoryID !== savedInRadioValues.serverOnly &&
      procedureFileData.forEach((fileData: any, index: any) => {
        const statusData = fileData.data.find((item: any) => item.name === "status");
        const applyForValue = fileData.data.find((item: any) => item.name === "applyfor").value;
        if ((statusData.value === null || statusData.value === "") && applyForValue === "JB") {
          procedureFileData[index].isError = true;
          isTableError = true;
          errorIndexList.push(index);
          // @ts-ignore
          applyJbApproveRef.current.updateDataList(procedureFileData);
          tableErrorList.push(statusData);
        }
      });
    const applyfor =
      this.props.applyJBStatus.applyfor !== this.props.applyJBStatus.jbProcedureSavedIn
        ? this.props.applyJBStatus.applyfor.trim()
        : "";
    if (
      this.props.applyJBStatus.procedureSaveInCategoryID !== savedInRadioValues.systemOnly &&
      // @ts-ignore
      procedureJbStatus[applyfor] === "JB" &&
      // @ts-ignore
      (applyJbApproveRef.current.getServerPathStatus() === null ||
        applyJbApproveRef.current.getServerPathStatus() === undefined)
    ) {
      this.handleApproveSubmitClickCheckRequired();
    } else if (
      isTableError &&
      this.props.applyJBStatus.procedureSaveInCategoryID !== savedInRadioValues.serverOnly
    ) {
      const firstErrorTr = document.getElementById(`table-tr-${errorIndexList[0]}`);
      // @ts-ignore
      this.handleControlErrorScroll(firstErrorTr.offsetTop + firstErrorTr.clientHeight);
    } else {
      // @ts-ignore
      this.handleCreateActionClickSectionCheckModal(
        "",
        this.modalContentLabels.submitConfirmModalLabel,
        () => this.handleSubmitOkClick(procedureFileData),
        this.hideModal
      );
    }
  };

  handleSubmitClick = () => {
    // @ts-ignore
    const procedureFileData =
      applyJbApproveRef.current === null ? [] : applyJbApproveRef.current.getDataList();
    let tableErrorList: any[] = [];
    this.handleApproveSubmitClickCheck(procedureFileData, tableErrorList);
  };

  _checkStepPermissionSuccess = (result: any) => {
    this.hideLoading();
    const { statusCode } = result;
    const noPermission = statusCode !== 200;
    this.props.setPermission(noPermission);
    if (noPermission) return;
    this.handleSubmitClick();
  };

  checkStepPermission = () => {
    this.showLoading();
    const params = {
      taskID: this.props.params.ProcedureTaskId,
      procedureID: this.props.params.ProcedureID,
      procedureStepID: this.props.params.ProcedureStepID,
      parentPage: null,
    };
    appService.checkStepPermission(params, this._checkStepPermissionSuccess, (response: any) =>
      console.log(response.message)
    );
  };

  handleReturnSubmitButton = (isSubmitDisabled: any) => (
    <Buttons
      color="blue"
      size="middle"
      onClick={this.checkStepPermission}
      disabled={isSubmitDisabled}
      btnClassName={styles.approveActionSubmitBtn}
      testid="apply-jb-submit-btn"
    >
      Submit
    </Buttons>
  );

  handleActionButton = () => {
    return (
      <div className={styles.actionBtns}>
        <div className={styles.normalBtns}>
          {this.handleReturnCancelButton(this.state.pageState.isCancelDisabled)}
          {this.handleReturnSubmitButton(this.state.pageState.isSubmitDisabled)}
        </div>
      </div>
    );
  };

  handleConfirmModal = () => {
    const {
      modalTitle,
      modalLabel,
      okText,
      cancelText,
      closable,
      isOkBtnDisabled,
      isCancelBtnDisabled,
      maskClosable,
      isModalWithComponentOpen,
      isShowTextArea,
      textAreaPlacement,
      textAreaMaxLength,
      textAreaClassName,
      modalWidth,
      handleOk,
      handleCancel,
    } = this.state.modalState;
    return (
      // @ts-ignore
      <ModalWithComponent
        isModalOpen={isModalWithComponentOpen}
        closable={closable}
        okText={okText}
        cancelText={cancelText}
        title={modalTitle}
        handleOk={handleOk}
        handleCancel={handleCancel}
        isOkDisabled={isOkBtnDisabled}
        isCancelDisabled={isCancelBtnDisabled}
        maskClosable={maskClosable}
        isShowTextArea={isShowTextArea}
        textAreaOnChange={(this as any).handleSetRejectValue}
        textAreaPlacement={textAreaPlacement}
        textAreaMaxLength={textAreaMaxLength}
        textAreaClassName={textAreaClassName}
        label={modalLabel}
        modalWidth={modalWidth}
        testid="apply-jb-confirm-modal"
      />
    );
  };

  ReleaseLock = () => {
    const para = {
      procedureId: this.props.params.ProcedureID,
      procedureSectionType: "ApplyForJB",
      setLock: false,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        this.props.closePage();
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  };

  showLoading = () => {
    disableInteraction();
    this.setState({
      loading: true,
    });
  };

  hideLoading = async () => {
    await enableInteraction();
    this.setState({
      loading: false,
    });
  };

  bindEvent = (procedureID: any) => {
    // @ts-ignore
    this.unbindUnloadUnlock = bindUnloadUnlock(
      () => true,
      () => {
        ProcedureDetailService.releaseLockOnUnload({
          procedureId: procedureID,
          procedureSectionType: "ApplyForJB",
        });
      }
    );
  };

  componentDidMount() {
    super.componentDidMount();
    this.bindEvent(this.props.params.ProcedureID);
  }

  componentWillUnmount() {
    // @ts-ignore
    this.unbindUnloadUnlock?.();
  }
}
